export default "__VITE_ASSET__Css_minr__"